const { userAgent } = navigator;
const userAgentLowerCase = userAgent.toLowerCase();
// const common2tEnv = window.common.env;

/**
 * 是否小程序环境
 */
export function isMiniprogram() {
  return window.__wxjs_environment === 'miniprogram' || userAgent.includes('miniProgram');
}

/**
 * 是否微信环境
 */
export function isWeChat() {
  return userAgentLowerCase.includes('micromessenger');
}

/**
 * 苹果桌面快捷方式
 */
export function isiOSDeskTop() {
  return userAgentLowerCase.includes('applewebkit') && window.navigator.standalone;
}

/**
 * 安卓桌面安装包快捷方式
 */
export function isAndroidDeskTop() {
  return !!userAgent.match(/\(i[^;]+;( U;)? CPuserAgent.+Mac OS X/) && userAgent.includes('SupperApp_Android');
}

/**
 * 是否android终端
 */
export function isAndroid() {
  return userAgent.includes('Android');
}

/**
 * 是否IOS终端
 */
export function isiOS() {
  return !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/**
 * 是否iPad
 */
export function isiPad() {
  return !!userAgent.includes('iPad');
}

/**
 * 是否PC端
 */
export function isPC() {
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;
  if (isiOS() || isAndroid()) {
    return false;
  }
  for (let i = 0; i < Agents.length; i++) {
    if (userAgent.includes(Agents[i])) {
      flag = false;
      break;
    }
  }
  return flag;
}

/**
 * 局部变量用于闭包存储
 */
let _sysEnv = null as null | Set<string>;
/**
 * 获取当前运行环境
 * @param envArray - 需要设置特定的环境,区分当前处于具体的应用里面
 */
export function getSysEnv(envArray = [] as string[]) {
  if (_sysEnv) {
    return _sysEnv;
  }
  // 环境
  const env = (_sysEnv = new Set(envArray));

  // WPS客户端
  const inWpsClient = () => {
    // if (common2tEnv.isClient()) {
    //   // 是否是客户端
    //   env.add('wps');
    //   if (isPC()) {
    //     // 桌面客户端
    //     env.add('pc-wps');
    //   } else {
    //     // 原生客户端
    //     env.add('native-wps');
    //   }
    //   // 2019 版 wps 客户端
    //   if (common2tEnv.isWps2019()) {
    //     env.add('wps2019');
    //   }
    // }
  };

  // 金山系列的App原生客户端
  const inKSApp = () => {
    // WOA
    if (userAgentLowerCase.includes('android-woa') || userAgentLowerCase.includes('ios-woa')) {
      env.add('native-app');
      env.add('woa');
    }

    // 金山文档
    if (userAgentLowerCase.includes('m-kdocs')) {
      env.add('native-app');
      env.add('kdocs');
    }

    // YUN
    if (userAgentLowerCase.includes('yun-android') || userAgentLowerCase.includes('yun-ios')) {
      env.add('native-app');
      env.add('yun');
    }

    // WPS OFFICE
    if (userAgentLowerCase.includes('wpsmoffice')) {
      env.add('native-app');
      env.add('wpsmoffice');
    }
  };

  // 微信客户端
  const inWechat = () => {
    // 微信小程序h5页面
    if (isMiniprogram()) {
      env.add('miniprogram');
    } else if (isWeChat()) {
      // 微信h5页面
      env.add('wechat');
    }
  };

  // 其他环境
  const otherEnv = () => {
    if (isAndroid()) {
      // 安卓端
      env.add('android');

      if (isAndroidDeskTop()) {
        // 安卓桌面安装包快捷方式
        env.add('androidDeskTop');
      }
    } else if (isiPad()) {
      // iPad
      env.add('ipad');
    } else if (isiOS()) {
      // 苹果端
      env.add('ios');
      if (isiOSDeskTop()) {
        // 苹果桌面快捷方式
        env.add('iosDeskTop');
      }
    } else if (isPC()) {
      // PC桌面端
      env.add('pc');
    } else {
      // 浏览器的模拟手机模式
      env.add('others');
    }
  };

  // WPS客户端
  // inWpsClient();
  // 金山系列的App原生客户端
  // inKSApp();
  // // 微信客户端
  // inWechat();
  // 其他环境
  otherEnv();

  return env;
}

/**
 * 获取当前环境值处于那个APP
 */
export function getSysEnvValue() {
  const env = getSysEnv();

  if (env.has('woa')) {
    return 'woa';
  }
  if (env.has('yun')) {
    return 'yun';
  }
  if (env.has('kdocs')) {
    return 'kdocs';
  }
  if (env.has('wpsmoffice')) {
    return 'wpsmoffice';
  }
}
